export default __webpack_public_path__ + "static/media/blurred-placeholder.a69044cc.png";